import { render, staticRenderFns } from "./breed.vue?vue&type=template&id=c8f8b088&"
import script from "./breed.vue?vue&type=script&lang=js&"
export * from "./breed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports